/**
 * @generated SignedSource<<56d02cfffb3e6bab7d8ea26a4f78cbee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrgSpaceActiveInfoScreenListItem_SpaceActiveConnectionNode$data = {
  readonly activeDashboards: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly activeStorecastWithSpaceCount: number;
  readonly store: {
    readonly id: string;
    readonly name: string;
    readonly timezone: string;
  } | null;
  readonly " $fragmentType": "OrgSpaceActiveInfoScreenListItem_SpaceActiveConnectionNode";
};
export type OrgSpaceActiveInfoScreenListItem_SpaceActiveConnectionNode$key = {
  readonly " $data"?: OrgSpaceActiveInfoScreenListItem_SpaceActiveConnectionNode$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrgSpaceActiveInfoScreenListItem_SpaceActiveConnectionNode">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrgSpaceActiveInfoScreenListItem_SpaceActiveConnectionNode",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Store",
      "kind": "LinkedField",
      "name": "store",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timezone",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "activeStorecastWithSpaceCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Dashboard",
      "kind": "LinkedField",
      "name": "activeDashboards",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "SpaceActiveConnectionNode",
  "abstractKey": null
};
})();

(node as any).hash = "bd9485aae70134d5d1b9d30ff6a0aeb1";

export default node;
